import { api } from '@marketplace-web/core-api/core-api-client-util'

import {
  KycEducationInfoResp,
  BankStatementEducationResp,
  getKycPhotoTipTypeResp,
} from '../types/pay-identity-kyc'

export const getKycEducationInfo = () =>
  api.get<KycEducationInfoResp>('/payments/identity/education')

export const getBankStatementEducation = () =>
  api.get<BankStatementEducationResp>('/payments/identity/educations/bank_statement')

export const getKycPhotoTipType = () =>
  api.get<getKycPhotoTipTypeResp>('/payments/identity/educations/photo_tips')
